import LockIcon from '@/app/icons/lock'
import { IGif } from '@giphy/js-types'

const PrivacyOverlay = ({ gif }: { gif: IGif }) => {
    return gif.is_hidden ? (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center select-none">
            <LockIcon className="size-10 fill-giphyRed" />
        </div>
    ) : null
}

export default PrivacyOverlay
